import { Auth } from "aws-amplify";

const AWS = require("aws-sdk");

const InvokeLambda = {
  invoke: (functionName, orgItem, integration) => {
    const obj = { orgItem: orgItem, integration: integration };
    const body = JSON.stringify(obj, null, " ");
    return Auth.currentCredentials().then(credentials => {
      const lambda = new AWS.Lambda({
        region: "ap-northeast-1",
        credentials: Auth.essentialCredentials(credentials)
      });

      return new Promise((resolve, reject) => {
        // lambda.invokeAsync(
        //   {
        //     FunctionName: functionName,
        //     InvokeArgs: body
        //   },
        lambda.invoke(
          {
            FunctionName: functionName,
            Payload: body
          },
          (err, data) => {
            if (err) {
              console.dir(err);
              reject(new Error("Lambda関数を起動できません"));
            }
            resolve(data);
          }
        );
      });
    });
  }
};

export default InvokeLambda;



// WEBPACK FOOTER //
// ./src/logic/InvokeLambda.js